
import Vue from 'vue';
import toast from './toast.vue';

export default {
  install(Vue) {

    const defaults = {
      show: false,
      text: '系统异常，请稍后重试。',
      duration: '3000',
      type: 'none'
    };

    const toastVueConstructor = Vue.extend(toast);
    toastVueConstructor.prototype.close = function () {
      var vm = this;
      this.$on('after-leave', _ => {
        if (vm.$el && vm.$el.parentNode) {
          vm.$el.parentNode.removeChild(vm.$el);
        }
        this.$destroy();
      });
      vm.show = false;

    };

    Vue.prototype.$toast = (options = {}) => {
      if (Vue.prototype.$isServer) return;
      options = Object.assign({}, defaults, options);
      let parent = document.body;
      let instance = new toastVueConstructor({
        el: document.createElement('div'),
        data: options
      });
      parent.appendChild(instance.$el);
      Vue.nextTick(() => {
        instance.show = true;
        setTimeout(function () {
          instance.close();
        }, options.duration)
      });


      return instance;
    };
  },
};